(function () {
  'use strict';
  var tag = document.getElementById('epf-shop-click-tracking');
  if (!tag || document.documentElement.hasAttribute('data-epf-click-tracking')) return;
  document.documentElement.setAttribute('data-epf-click-tracking', '1');
  var measurement = 'G-Y88GNMQYHH';
  var pageType = tag.getAttribute('data-page-type');
  var article = tag.getAttribute('data-article-handle') || '';
  var debug = new URLSearchParams(location.search).get('epf_tracking_debug') === '1';
  var panel;
  function status(message) {
    if (!debug) return;
    if (!panel) {
      panel = document.createElement('output');
      panel.id = 'epf-tracking-diagnostic';
      panel.setAttribute('aria-label', 'EPF tracking diagnostic');
      panel.style.cssText = 'position:fixed;bottom:12px;left:12px;z-index:99999;padding:12px;background:#111;color:#fff;font:12px monospace;max-width:520px;white-space:pre-wrap;pointer-events:none';
      document.body.appendChild(panel);
    }
    panel.textContent = message;
  }
  function allowed() {
    try { return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed() === true); }
    catch (_) { return false; }
  }
  function refresh() { status('EPF click tracking ready | Analytics allowed: ' + allowed()); }
  if (window.Shopify && Shopify.loadFeatures) {
    Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], refresh);
  } else refresh();
  document.addEventListener('visitorConsentCollected', refresh);
  var handled = new WeakSet();
  document.addEventListener('click', function (event) {
    if (handled.has(event)) return;
    handled.add(event);
    var anchor = event.target && event.target.closest && event.target.closest('a[href]');
    if (!anchor || !anchor.closest('main') || anchor.hasAttribute('download')) return;
    var url;
    try { url = new URL(anchor.href, location.href); } catch (_) { return; }
    if (url.origin !== location.origin) return;
    if (pageType === 'product' && anchor.classList.contains('epf-fitment-jump') && url.pathname === location.pathname && url.hash === '#epf-vehicle-fitment' && document.getElementById('epf-vehicle-fitment')) {
      if (!allowed()) { status('Fitment click skipped | Analytics consent not allowed'); return; }
      var fitmentLoader = Array.from(document.querySelectorAll('script[src]')).some(function (s) { return s.src.indexOf('googletagmanager.com/gtag/js') >= 0 && s.src.indexOf(measurement) >= 0; });
      if (!fitmentLoader || typeof window.gtag !== 'function') return;
      var fitmentPayload = {send_to:measurement,source_page_type:'product',source_path:location.pathname,product_handle:location.pathname.split('/products/')[1] || '',link_text:'Check full vehicle fitment',transport_type:'beacon'};
      if (debug) fitmentPayload.debug_mode = true;
      window.gtag('event','epf_fitment_click',fitmentPayload);
      status('Queued epf_fitment_click\n' + JSON.stringify(fitmentPayload,null,2));
      return;
    }
    var path = url.pathname.replace(/\/$/, '');
    var product = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?(?:\/collections\/[a-z0-9-]+)?\/products\/[a-z0-9-]+$/i.test(path);
    var collection = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/[a-z0-9-]+$/i.test(path);
    if (!product && !collection) return;
    var label = (anchor.textContent || anchor.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim();
    var cta = !!anchor.closest('.button,.btn,[data-epf-cta],.epf-shop-cta') || /\b(shop|buy|find|browse|explore|view)\b/i.test(label);
    var inArticle = pageType === 'article' && !!anchor.closest('.prose');
    if (!inArticle && !cta) return;
    if (!allowed()) { status('Click skipped | Analytics consent not allowed'); return; }
    var existingLoader = Array.from(document.querySelectorAll('script[src]')).some(function (s) { return s.src.indexOf('googletagmanager.com/gtag/js') >= 0 && s.src.indexOf(measurement) >= 0; });
    if (!existingLoader || typeof window.gtag !== 'function') { status('Click skipped | Existing EPF Google tag not ready'); return; }
    var payload = {
      send_to: measurement,
      click_type: inArticle ? (product ? 'blog_product' : 'blog_collection') : 'shop_cta',
      source_page_type: pageType || 'unknown',
      source_path: location.pathname,
      article_handle: article,
      destination_path: path,
      destination_type: product ? 'product' : 'collection',
      link_text: label.slice(0,100),
      is_cta: cta ? 'yes' : 'no',
      transport_type: 'beacon'
    };
    if (debug) payload.debug_mode = true;
    window.gtag('event','epf_shop_click',payload);
    status('Queued epf_shop_click\n' + JSON.stringify(payload,null,2));
  }, true);

  var checkoutHandled = new WeakSet();
  document.addEventListener('submit', function (event) {
    if (checkoutHandled.has(event)) return;
    checkoutHandled.add(event);
    var button = event.submitter;
    var form = event.target;
    if (!button || button.name !== 'checkout' || !form || !form.closest) return;
    var surface = form.closest('#cart-drawer') ? 'cart_drawer' : form.closest('.epf-cart-page') ? 'cart_page' : '';
    if (!surface) return;
    if (!allowed()) { status('Checkout click skipped | Analytics consent not allowed'); return; }
    var checkoutLoader = Array.from(document.querySelectorAll('script[src]')).some(function (s) { return s.src.indexOf('googletagmanager.com/gtag/js') >= 0 && s.src.indexOf(measurement) >= 0; });
    if (!checkoutLoader || typeof window.gtag !== 'function') { status('Checkout click skipped | Existing EPF Google tag not ready'); return; }
    var checkoutPayload = {send_to:measurement,checkout_surface:surface,source_page_type:pageType || 'unknown',source_path:location.pathname,transport_type:'beacon'};
    if (debug) checkoutPayload.debug_mode = true;
    window.gtag('event','epf_checkout_click',checkoutPayload);
    status('Queued epf_checkout_click\n' + JSON.stringify(checkoutPayload,null,2));
  }, true);
})();
